import * as api from '../api/adapters/json_api';
import { getShowArchivedInSelects } from '../showArchived';

// FIN-1211: types whose options can be archived and hidden by default.
const ARCHIVABLE_TYPES = ['companies', 'vessels'];

export default {

  index: async ({ search, type, filters, ...rest }) => {
    // Reveal archived companies/vessels only when the global admin flag is on
    // (enum lookups are unaffected). Merged into filters so existing ones survive.
    const includeArchived =
      ARCHIVABLE_TYPES.includes(type) && !rest.enum && getShowArchivedInSelects();
    const mergedFilters = includeArchived
      ? { ...(filters || {}), include_archived: true }
      : filters;

    const { data } = await api.read('select_options', {
      query: {
        q: search,
        type,
        ...(mergedFilters !== undefined ? { filters: mergedFilters } : {}),
        ...rest,
      },
    });

    return data;
  },
};
